/* tslint:disable */
/* eslint-disable */
export enum PackageState {
  TRANSIT = 0,
  DELIVERED = 1,
  REFUSED = 2,
}
